import { render, staticRenderFns } from "./CameraAccessSettings.vue?vue&type=template&id=88d8e254&"
import script from "./CameraAccessSettings.vue?vue&type=script&lang=js&"
export * from "./CameraAccessSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports